import {
  Component,
  OnInit,
  Input,
  ViewChild,
  AfterViewInit,
  Output,
  EventEmitter,
  OnDestroy
} from '@angular/core';
import { Store } from '@ngrx/store';
import {
  SuccessStore,
  AuthActionTypes,
  ResetPassword,
  LoginRedirect,
  AppConfigSettings
} from '@arc/arc-shared-frontend';

import { filter } from 'rxjs/operators';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-authentication-passwordreset-container',
  templateUrl: './passwordreset.container.component.html',
  styleUrls: ['./passwordreset.container.component.scss']
})
export class PasswordresetContainerComponent implements OnInit, OnDestroy {
  emailsent = false;
  msgs = [];
  private subs = new SubSink();

  @Output()
  goBackClicked = new EventEmitter();

  @Output()
  onResetPasswordSucceeded = new EventEmitter();

  @Output()
  onResetPasswordError = new EventEmitter();

  constructor(private store: Store<any>, public settings: AppConfigSettings) {}

  ngOnInit() {
    this.subs.add(
      this.store
        .select(SuccessStore)
        .pipe(filter(x => x && x.actionType === AuthActionTypes.ResetPassword))
        .subscribe(x => {
          this.onResetPasswordSucceeded.emit();
        })
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  onResetPasswordClick($event) {
    this.store.dispatch(new ResetPassword($event));
  }

  goBack($event) {
    this.goBackClicked.emit();
    this.store.dispatch(new LoginRedirect(null));
  }
}
